<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="headline primary white--text">
        Mudança de Senha
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="formValid" @submit.prevent="save">
          <v-container>
            <!-- Campo Nome -->
            <v-text-field v-model="usuario.nomeUsuario" label="Nome" disabled outlined class="mb-4"></v-text-field>

            <!-- Nova Senha -->
            <v-text-field v-model="editedItem.passwordnew" :rules="passwordRules" label="Nova senha" outlined
              type="text" required></v-text-field>

            <!-- Indicador de Força -->
            <div v-if="editedItem.passwordnew" class="mt-2">
              <v-progress-linear :value="passwordStrength(editedItem.passwordnew)" height="6" :color="strengthColor"
                striped></v-progress-linear>
              <div class="text-caption mt-1" :class="strengthTextColor">
                {{ strengthText }}
              </div>
            </div>

            <!-- Botão Gerar Senha -->
            <div class="text-center mt-4">
              <v-btn color="secondary" @click="generatePassword" class="mb-4">
                <v-icon left>mdi-lock</v-icon>
                Gerar Senha Automática
              </v-btn>
            </div>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="fecharComponente">
          Cancelar
        </v-btn>
        <v-btn color="primary" :disabled="!formValid" @click="save" :loading="loading">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from '../../../plugins/axios'
import Swal from 'sweetalert2'
import generator from 'generate-password'
const ls = require("local-storage");

export default {
  props: {
    usuario: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    formValid: true,
    dialog: true,
    loading: false,
    showPassword: false,
    editedItem: {
      passwordnew: ''
    },
    passwordRules: [
      value => !!value || "Campo obrigatório",
      value => (value && value.length >= 8) || "Mínimo 8 caracteres",
      value => /[A-Z]/.test(value) || "Pelo menos 1 letra maiúscula",
      value => /[a-z]/.test(value) || "Pelo menos 1 letra minúscula",
      value => /[0-9]/.test(value) || "Pelo menos 1 número",
      value => /[^A-Za-z0-9]/.test(value) || "Pelo menos 1 caractere especial"
    ]
  }),

  created() {
    this.editedItem = {
      ...this.usuario,
      passwordnew: ''
    }
    this.generatePassword()
  },

  computed: {
    fkUsuario() {
      return ls.get("pkUsuario");
    },
    strengthColor() {
      const strength = this.passwordStrength(this.editedItem.passwordnew)
      if (strength < 50) return 'red'
      if (strength < 80) return 'orange'
      return 'green'
    },
    strengthTextColor() {
      return this.strengthColor + '--text'
    },
    strengthText() {
      const strength = this.passwordStrength(this.editedItem.passwordnew)
      if (strength < 50) return 'Senha fraca'
      if (strength < 80) return 'Senha média'
      return 'Senha forte'
    }
  },



  methods: {
    generatePassword() {
      const generatedPassword = generator.generate({
        length: 12,
        numbers: true,
        lowercase: true,
        uppercase: true,
        symbols: true,
        strict: true
      })
      this.$set(this.editedItem, 'passwordnew', generatedPassword) // ✅ GARANTE REATIVIDADE
      this.$nextTick(() => {
        this.$refs.form.validate()
      })
    },

    passwordStrength(password) {
      if (!password) return 0
      let score = 0
      score += Math.min(25, (password.length / 12) * 25)
      if (/[A-Z]/.test(password)) score += 15
      if (/[a-z]/.test(password)) score += 15
      if (/[0-9]/.test(password)) score += 15
      if (/[^A-Za-z0-9]/.test(password)) score += 15
      if (password.length < 8) score -= 20
      if (password === this.usuario.nomeUsuario) score = 0
      return Math.max(0, Math.min(100, score))
    },

    async save() {
      if (!this.$refs.form.validate()) return

      this.loading = true
      try {
        const params = {
          pkUsuario: this.usuario.pkUsuario,
          password: this.editedItem.passwordnew,
          email: this.usuario.Usuario_username,
          fkUsuario: this.fkUsuario
        }

        const response = await axios.post('/mudarSenhaByUser', params)

        if (response.data.affectedRows) {
          Swal.fire({
            title: 'Senha alterada com sucesso',
            html: `<p>Nova senha: <strong style="color:red;font-size:1.2em;">${this.editedItem.passwordnew}</strong></p>
                  <p>Guarde esta senha e forneça ao usuário.</p>`,
            icon: 'success',
            confirmButtonText: 'OK'
          })
          this.fecharComponente()
        }
      } catch (error) {
        Swal.fire({
          title: 'Erro',
          text: 'Ocorreu um erro ao alterar a senha',
          icon: 'error'
        })
      } finally {
        this.loading = false
      }
    },

    fecharComponente() {
      this.$emit('fecharComponente', false)
    }
  }
}
</script>

<style scoped>
.v-card__title {
  padding: 16px;
}

.v-card__actions {
  padding: 8px 16px;
}
</style>
